import type { paths } from "@/api-schema";
import { encodeLogoRequest } from "@/common/helpers/encode-file";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRAND_CREATE_RESOURCE = "brand" as const;
export const BRAND_CREATE_API_PATH = `/v1/${BRAND_CREATE_RESOURCE}` as const;

export type BrandCreateBody = paths[typeof BRAND_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type BrandCreateInput = Omit<BrandCreateBody, "logo"> & {
  logo?: File;
};
export type BrandCreateResponse =
  paths[typeof BRAND_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useBrandCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BrandCreateResponse, Error, BrandCreateInput>({
    mutationFn: async (data: BrandCreateInput) => {
      const response = await alphartisApiAxios.post<BrandCreateResponse>(
        BRAND_CREATE_API_PATH,
        await encodeLogoRequest(data),
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRAND_CREATE_RESOURCE],
      });
    },
  });
};
